import { render } from "./ResultInfo.vue?vue&type=template&id=81357ed4"
import script from "./ResultInfo.vue?vue&type=script&lang=js"
export * from "./ResultInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__